import React from "react";
import { useAuth0 } from '../../auth/useAuth0';
import { useTranslation } from "react-i18next";
import { logoutBusinessLocalStorage } from "../../util/local-storage-service";

const NotFoundComponent: React.FC = () => {
    const { t } = useTranslation();
    const { isAuthenticated, isLoading, logout, loginWithRedirect } = useAuth0();

    const forceLogout = () => {
        try {
            logoutBusinessLocalStorage();
            localStorage.clear();
            sessionStorage.clear();
        } catch (e) {
            console.error("Failed to clear local storage", e);
        }
        logout({ logoutParams: { returnTo: window.location.origin } });
    };

    const goToLogin = () => {
        loginWithRedirect({
            authorizationParams: { redirect_uri: window.location.origin },
        });
    };

    if (isLoading) {
        return <div className="container py-5 text-center" data-cy="notfound-loading">{t('common.loading')}</div>;
    }

    return (
        <div
            className="container py-5 text-center"
            style={{ maxWidth: 520 }}
            data-cy="notfound-page"
        >
            <h1 className="display-5 mb-3">{t('notFound.title')}</h1>
            <p className="text-muted mb-4">
                {t('notFound.description')}
            </p>

            <div className="d-grid gap-2">
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={forceLogout}
                    data-cy="notfound-force-logout-btn"
                >
                    {t('notFound.forceLogout')}
                </button>

                {!isAuthenticated && (
                    <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={goToLogin}
                        data-cy="notfound-go-to-login-btn"
                    >
                        {t('notFound.backToLogin')}
                    </button>
                )}
            </div>

            <p className="text-muted small mt-4 mb-0">
                {t('notFound.statusLabel')}{" "}
                {isAuthenticated
                    ? t('notFound.statusAuthenticated')
                    : t('notFound.statusNotAuthenticated')}
            </p>
        </div>
    );
};

export default NotFoundComponent;
